module.exports = __webpack_public_path__ + "img/illu-grass.91492d4f.svg";